<template>
  <a-empty :image="simpleImage" />
</template>

<script setup>
import { Empty } from 'ant-design-vue';
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
</script>

<style lang='less' scoped></style>